import { FC } from 'react';
import CrossSvg from '@edikk-edikk/country-layout-black-icon/src/cross.svg';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useMenuContext, useMenuState } from '#baseMenu/hooks';

const ButtonHide: FC = () => {
  const { hide, isOpen } = useMenuContext();
  const { isActionsBlocked } = useMenuState();

  if (!isOpen) {
    return null;
  }

  return (
    <Button
      variant={ButtonVariant.white65}
      circle
      onClick={hide}
      additionalClassName="flex-shrink-0"
      aria-label="Hide menu"
      pointerEventsNone={isActionsBlocked}
    >
      <SvgIcon Component={CrossSvg} width={14} height={14} />
    </Button>
  );
};

export { ButtonHide };
